import { render, staticRenderFns } from "./RootFabbricatiView.vue?vue&type=template&id=4f01a5d8&"
import script from "./RootFabbricatiView.vue?vue&type=script&lang=ts&"
export * from "./RootFabbricatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports